export default __webpack_public_path__ + "static/media/bar4Animation.831fd05a.svg";